import createIcon from '../../createIcon';

/**
 * @component @name VideogameAsset
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgzQzEuOSA2IDEgNi45IDEgOFYxNkMxIDE3LjEgMS45IDE4IDMgMThIMjFDMjIuMSAxOCAyMyAxNy4xIDIzIDE2VjhDMjMgNi45IDIyLjEgNiAyMSA2Wk0xMSAxM0g4VjE2SDZWMTNIM1YxMUg2VjhIOFYxMUgxMVYxM1pNMTUuNSAxNUMxNC42NyAxNSAxNCAxNC4zMyAxNCAxMy41QzE0IDEyLjY3IDE0LjY3IDEyIDE1LjUgMTJDMTYuMzMgMTIgMTcgMTIuNjcgMTcgMTMuNUMxNyAxNC4zMyAxNi4zMyAxNSAxNS41IDE1Wk0xOS41IDEyQzE4LjY3IDEyIDE4IDExLjMzIDE4IDEwLjVDMTggOS42NyAxOC42NyA5IDE5LjUgOUMyMC4zMyA5IDIxIDkuNjcgMjEgMTAuNUMyMSAxMS4zMyAyMC4zMyAxMiAxOS41IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideogameAsset = createIcon('VideogameAsset', [
  [
    'path',
    {
      d: 'M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM11 13H8V16H6V13H3V11H6V8H8V11H11V13ZM15.5 15C14.67 15 14 14.33 14 13.5C14 12.67 14.67 12 15.5 12C16.33 12 17 12.67 17 13.5C17 14.33 16.33 15 15.5 15ZM19.5 12C18.67 12 18 11.33 18 10.5C18 9.67 18.67 9 19.5 9C20.33 9 21 9.67 21 10.5C21 11.33 20.33 12 19.5 12Z',
      key: '7h4l4f',
    },
  ],
]);

export default VideogameAsset;
